import React, { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import LoadingSpinner from "../components/common/LoadingSpinner";

const WelcomePage: React.FC = () => {
  const { user, navigateToDashboard, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) {
      // If user is logged in, redirect to their appropriate dashboard
      navigateToDashboard();
    }
  }, [user, loading, navigateToDashboard]);

  if (loading) {
    return <LoadingSpinner />;
  }

  // If not logged in, render the enhanced landing page content
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="mb-8">
              <img
                src="/school-logo.png"
                alt="ATIAM College"
                className="h-24 w-auto mx-auto mb-6"
              />
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Welcome to <span className="text-green-800">ATIAM</span> College
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Comprehensive Management System for seamless administration of
              academic operations, student management, and institutional
              excellence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/login"
                className="bg-green-800 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-900 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Access Your Dashboard
              </a>
              <a
                href="/register/ecourse"
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Enroll in E-Courses
              </a>
            </div>
          </div>
        </div>

        {/* Background decoration */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-green-100 rounded-full opacity-20"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-100 rounded-full opacity-20"></div>
        </div>
      </section>
    </div>
  );
};

export default WelcomePage;
